var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonGenericV2',{attrs:{"text":_vm.getButtonMap.text},on:{"click":_vm.goToResults}})}
var staticRenderFns = []

export { render, staticRenderFns }